import { createAction } from '@ngrx/store';

export const GetNews = createAction('[NEWS] Get News', (payload = null) => ({
  payload
}));
export const GetNewsSuccess = createAction(
  '[NEWS] Get News Success',
  (payload = null) => ({ payload })
);
export const GetNewsFailure = createAction(
  '[NEWS] Get News Failure',
  (payload = null) => ({ payload })
);

export const GetSocialMediaLinks = createAction(
  '[NEWS] Get Social Media Links',
  (payload = null) => ({ payload })
);
export const GetSocialMediaLinksSuccess = createAction(
  '[NEWS] Get Social Media Links Success',
  (payload = null) => ({ payload })
);
export const GetSocialMediaLinksFailure = createAction(
  '[NEWS] Get Social Media Links Failure',
  (payload = null) => ({ payload })
);
